<template>
  <div id="home">
    <div  class="container">
      <div class="image" v-if="$store.state.isDesktop"></div>
      <div class="content" :class="{image: !$store.state.isDesktop}" >
        <div class="title">{{ $store.state.cogir ? $t("home.cogir.title") : $t("home.title_1") }}</div>
        <div class="subtitle" v-if="!$store.state.cogir">{{ $t("home.subtitle_1") }}</div>
        <div class="description" v-if="!$store.state.cogir">{{ $t("home.description_1") }}</div>
        <div class="description" v-if="$store.state.cogir">
          {{ $t("home.cogir.description_1") }}
          <br><br>
          {{ $t("home.cogir.description_2") }}
          <br><br>
          {{ $t("home.cogir.description_3") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>


  export default {

    name: "home",

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "page.home",
        headerIcon: "/svg/home.svg"
      });
      setTimeout(()=>this.$forceUpdate(),0);
    }

  }

</script>

<style lang="scss" scoped>

  #home {
    position: relative;
    display: flex;
  }

  .container {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    & > div {
      width: 100%;
      min-width: 100%;
    }
  }

  .image {
    background-image: url(../assets/img/background-dashboard.png);
    background-size: cover;
    background-position: center;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    padding: 0 50px;
    color: white;
    text-align: center;
  }


  .subtitle {
    font-size: 20px;
    margin-bottom: 30px;
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {
    #home {
      flex-direction: column;
      flex-grow: 1;
    }

    .title {
      font-size: 40px;
      font-weight: 500;
      margin-bottom: 40px;
      text-transform: uppercase;
      &:after {
        content: "";
        width: 60px;
        height: 5px;
        background-color: white;
        display: block;
        left: 50%;
        bottom: -18px;
        position: relative;
        transform: translateX(-50%);
      }
    }

    .image {
      background-image: url(../assets/img/background-dashboard.png);
      background-size: cover;
      background-position: center;
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      justify-content: center;
      padding: 0 50px;
      color: white;
      text-align: center;
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #home {
      padding: 30px 60px 30px 60px;
      justify-content: center;
    }

    .container{
      flex-direction: column;
      border-radius: 5px;
      background-color: white;
      max-width: 500px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .image {
      background-image: url(../assets/img/background-dashboard.png);
      background-size: cover;
      background-position: center;
    }

    .content {
      display: flex;
      flex-direction:column;
      align-items: center;
      flex-basis: 0;
      flex-grow: 1;
      flex-shrink: 0;
      padding: 40px;
    }

    .title {
      font-weight: 500;
      font-size: 28px;
    }

    .description {
      font-size: 18px;
      color: #405159;
    }
  }

</style>